<template>
  <div class="industry-page">
    <div class="industry-page-container clearfix">
      <div class="industry-page-container-left">
        <industry-news-list></industry-news-list>
      </div>
      <div class="industry-page-container-right">
        <div class="industry-right-content tab_fix">
          <hot-ranking-list :title="'热门行业排行'"></hot-ranking-list>
        </div>
      </div>
    </div>
    <BackTop></BackTop>
  </div>
</template>

<script>
import HotRankingList from '@/components/news-monitor/HotRankingList';
import IndustryNewsList from '@/components/news-monitor/IndustryNewsList';
import BackTop from '@/components/common/BackTop';

export default {
  components: {
    IndustryNewsList,
    BackTop,
    HotRankingList
  }
};
</script>

<style lang="scss" scoped>
  .industry-page {
    width: 100%;
    min-width: 1218px;
    min-height: 100%;
    background: #333138;
    .industry-page-container {
      position:relative; 
      display: flex;
      margin: 0 auto;
      padding: 24px 0;
      width: 1204px;
      .industry-page-container-left {
        float: left;
        margin-right: 24px;
        width: 804px;
      }
      .industry-page-container-right {
        float: left;
        width: 376px;
        .industry-right-content {
          width: 376px;
          top: 88px;
        }
      }
    }
  }
.clearfix:after{
  content:'';
  display:block;
  clear:both;
  height:0;
  visibility:hidden;
}
.clearfix{
  zoom:1;
}
.tab_fix{
  position:fixed;
}
</style>
